define.alias("ember-truth-helpers/helpers/is-array", "preview-grid/helpers/is-array");